import React from 'react';
import AppRouter from './routes/App-router';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { LoaderProvider } from "./components/loader/loader-context";
import Loader from "./components/loader/g-loader"; 

const App = () => (
  <LoaderProvider> {/* Wrap the app with LoaderProvider */}
    <BrowserRouter>
      <Loader /> {/* Add Loader component to make it globally accessible */}
      <AppRouter />
    </BrowserRouter>
  </LoaderProvider>
);

export default App;
